import { AppProviders, LibraryProviders } from "web/Providers"
import { Controller } from "@hotwired/stimulus"
import React, { Suspense } from "react"
import { render } from "react-dom"
import { BrowserRouter as Router } from "react-router-dom"
import { ErrorBoundary, Loading, ModalContainer } from "web/components"
import OverviewLayout from "web/app/Settings/Templates/OverviewLayout"

export default class OverviewTemplateController extends Controller {
  static values = {
    id: Number,
  }

  initialize() {
    global.React = React
  }

  connect() {
    render(
      <Suspense fallback={<Loading />}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <ErrorBoundary>
                <OverviewLayout overviewTemplateId={this.idValue} />
              </ErrorBoundary>
              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }
}
